module.exports = __webpack_public_path__ + "assets/img/paper-cabinets.73ad81df.svg";